export const chargingPeriods = {
  methods: {
    getPeriodString(type, length) {
      const typesMap = {
        1: 'day',
        2: 'week',
        3: 'month',
        4: 'year'
      }
      return this.$tc(typesMap[type], length)
    },
    totalPriceGroupedByPeriod(subscriptions) {
      const grouped = subscriptions.reduce((group, subscription) => {
        const periodString = this.getPeriodString(subscription.period_type, subscription.period_length)
        group[periodString] = group[periodString] ? group[periodString] : []
        group[periodString].push(subscription)
        return group
      }, {})
      const groupedSum = {}
      for (const key in grouped) {
        if (grouped.hasOwnProperty(key)) {
          const sum = this.formatPrice(grouped[key].reduce(function(a, b) {
            return a + b['monthly_cost']
          }, 0))
          if (sum > 0) {
            groupedSum[key] = sum
          }
        }
      }
      console.log('groupedSum', groupedSum)
      return groupedSum
    }
  }
}
